import * as React from 'react'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const get = require('lodash/get')

export interface CopyToClipboardButtonProps {
	text?: string
	className?: string
}

type Clipboard = {
	writeText(text: string): Promise<void>
}

type ClipboardNavigator = {
	clipboard: Clipboard
}

// interface Navigator extends ClipboardNavigator {}

class CopyToClipboardButton extends React.PureComponent<CopyToClipboardButtonProps> {
	constructor(props) {
		super(props)

		this.handleClick = this.handleClick.bind(this)
	}

	// workaround for missing `clipboard` on Navigator type
	get clipboardNavigator(): any {
		return navigator
	}

	handleClick() {
		const { text } = this.props
		this.clipboardNavigator.clipboard.writeText(text!)
	}

  render() {
		const { className } = this.props

		return (
			<div onClick={this.handleClick} className={classnames('cursor-pointer', className)}>
				<FontAwesomeIcon icon={['fas', 'copy']} />
			</div>
		)
  }
}

export default CopyToClipboardButton



// WEBPACK FOOTER //
// ./src/common/CopyToClipboardButton.component.tsx